<template>
  <!--  -->
  <div>
    <el-dialog
      title="创建会诊"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      :center="true"
      :show-close="false"
      width="50%"
    >
      <span>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="会诊时间" required>
            <el-col :span="11">
              <el-form-item prop="date1">
                <el-date-picker
                  type="date"
                  placeholder="选择日期"
                  v-model="ruleForm.date1"
                  value-format="yyyy-MM-dd"
                  style="width: 100%"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col class="line" :span="2">-</el-col>
            <el-col :span="11">
              <el-form-item prop="date2">
                <el-time-picker
                  placeholder="选择时间"
                  v-model="ruleForm.date2"
                  value-format="HH:mm:ss"
                  style="width: 100%"
                ></el-time-picker>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item label="选择专家" prop="doctorList">
            <el-select
              v-model="ruleForm.doctorList"
              multiple
              placeholder="请选择"
            >
              <el-option
                v-for="item in options"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="就诊人">
            <el-input v-model="memberName" disabled></el-input>
          </el-form-item>
          <el-form-item label="价格" prop="money">
            <el-input
              v-model.number="ruleForm.money"
              type="number"
              oninput="if(value<0)value=0"
            ></el-input>
          </el-form-item>

          <el-form-item label="上传文件" prop="image">
            <el-upload
              :action="uploadUrl"
              list-type="picture-card"
              :on-success="uploadSuccess"
              :on-exceed="handleExceed"
              :before-upload="beforeAvatarUpload"
              :file-list="fileArr"
              :limit="3"
              multiple
            >
              <i slot="default" class="el-icon-plus"></i>

              <div slot="file" slot-scope="{ file }">
                <img class="el-upload-list__item-thumbnail" :src="file.url" />
                <span class="el-upload-list__item-actions">
                  <span
                    class="el-upload-list__item-preview"
                    @click="handlePictureCardPreview(file)"
                  >
                    <i class="el-icon-zoom-in"></i>
                  </span>

                  <span
                    v-if="!disabled"
                    class="el-upload-list__item-delete"
                    @click="handleRemove(file)"
                  >
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
              </div>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible2">
              <img width="100%" :src="dialogImageUrl" alt="" />
            </el-dialog>
          </el-form-item>
          <el-form-item label="会诊说明" prop="intro">
            <el-input type="textarea" v-model="ruleForm.intro"></el-input>
          </el-form-item>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { createdConsultation, getDoctorList, getAddDoctor} from "@/api/index.js";

export default {
  data() {
    return {
      uploadUrl: process.env.VUE_APP_BASE_API + "sys/upload/fileUpload",
      dialogImageUrl: "",
      fileArr: [],
      dialogVisible: false,
      dialogVisible2: false,
      disabled: false,
      ruleForm: {
        intro: "",
        image: "", //附件图
        doctorList: [], //专家列表
        orderTreatId: "",
        date1: "",
        date2: "",
        money: 0,
      },
      memberName: "",
      rules: {
        intro: [{ required: true, message: "请填写会诊说明", trigger: "blur" }],
        doctorList: [
          { required: true, message: "请选择专家", trigger: "select" },
        ],
        date1: [{ required: true, message: "请选择日期", trigger: "select" }],
        date2: [{ required: true, message: "请选择时间", trigger: "select" }],

        money: [
          {
            type: "number",
            min: 0,
            max: 10000,
            message: "请设置金额",
            trigger: "blur",
          },
        ],
      },
      options: [],
    };
  },
  created() {
    // this.getDoctorListInit();
    //乐荐屏蔽
  },
  methods: {
    getDoctorListInit() {
      getDoctorList().then((res) => {
        if (res.success) {
          this.options = res.result;
        }
      });
    },
    //限制上传数量
    handleExceed(files, fileList) {
      this.$message.error(`当前限制上传 3 份文件`);
    },
    //上传成功
    uploadSuccess(response, file, fileList) {
      this.fileArr = fileList;
    },
    //限制图片格式
    beforeAvatarUpload(file) {
      let isJPG = false;
      if (file.type === "image/jpeg" || file.type === "image/png") {
        isJPG = true;
      }
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传文件只能是 JPG和PNG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传文件大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    open(item) {
      this.ruleForm.orderTreatId = item.id;
      this.memberName = item.caseContent_dictText.memberName;
      this.dialogVisible = true;
    },
    close() {
      this.dialogVisible = false;
      this.fileArr = [];

      this.$refs["ruleForm"].resetFields();
    },
    //删除图片
    handleRemove(file) {
      let { name } = file;
      this.fileArr.forEach((e, i) => {
        if (e.name == name) {
          this.fileArr.splice(i, 1);
        }
      });
    },
    //查看大图
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible2 = true;
    },

    submitForm(formName) {
      let arr = [];
      if (this.fileArr.length != 0) {
        this.fileArr.forEach((e) => {
          arr.push(e.response.result.relativePath);
        });
      }
      this.ruleForm.image = arr.join(",");
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let { doctorList, image, intro, money, date1, date2, orderTreatId } =
            this.ruleForm;

          createdConsultation({
            image,
            intro,
            money,
            orderTreatId,
            startTime: date1 + " " + date2,
          }).then((res) => {
            if (res.success) {
              let consId = res.result.consId
              getAddDoctor({consId,doctorList}).then(val=>{
                console.log('创建成功后:',val);
              })
              this.close();
              this.$message("您的会诊信息已提交，等待患者确认!");
              // this.$emit("success", this.ruleForm.orderTreatId);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.primary {
  background-color: #409eff !important;
  border: 1px solid #409eff !important;
}
/deep/.line {
  text-align: center;
}
</style>